export default __webpack_public_path__ + "static/media/right-arrow3.f7848047.png";